/**
 * Brand page category cards (sections/brand-categories.liquid).
 * A card marked data-photo-vendor / data-photo-category has no photo of its own, so we ask the store's
 * product search for products of exactly that brand and category and use the photo of the first one that
 * has a picture. Results are remembered for the visit (sessionStorage); if nothing is found the card keeps
 * its icon.
 */
(() => {
  const cards = [...document.querySelectorAll('[data-photo-vendor][data-photo-category]')];
  if (!cards.length) return;

  const remembered = (key) => {
    try {
      return sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  };
  const remember = (key, value) => {
    try {
      sessionStorage.setItem(key, value);
    } catch (error) {
      /* private mode: no caching */
    }
  };

  async function findPhoto(vendor, category) {
    const key = `te-brand-photo:${vendor}:${category}`;
    const saved = remembered(key);
    if (saved !== null) return saved;
    let url = '';
    try {
      const query = encodeURIComponent(`vendor:"${vendor}" AND product_type:"${category}"`);
      const response = await fetch(`/search/suggest.json?q=${query}&resources[type]=product&resources[limit]=10`);
      if (response.ok) {
        const data = await response.json();
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        const match = products.find((p) => p.vendor === vendor && p.type === category && p.image);
        if (match) url = match.image;
      }
    } catch (error) {
      url = '';
    }
    remember(key, url);
    return url;
  }

  cards.forEach(async (card) => {
    const url = await findPhoto(card.dataset.photoVendor, card.dataset.photoCategory);
    if (!url) return;
    const media = card.querySelector('.brand-card__media');
    if (!media) return;
    const sized = new URL(url, window.location.origin);
    sized.searchParams.set('width', '600');
    const image = new Image();
    image.className = 'brand-card__photo';
    image.alt = '';
    image.src = sized.toString();
    image.addEventListener('load', () => media.replaceChildren(image), { once: true });
  });
})();
